<template>
  <transition name="fade">
    <div v-show="progress.overview.show">
      <section>
        <div class="selected">
          <h2 class="mb-5">{{ $t("overview") }}</h2>
          

          <div class="additionals-summary">
            <div class="row mb-5">
              <p class="mb-2">{{ $t("days") }}: {{ reservation.nights }}</p>
              <p class="mb-0">
                {{ $t("From") }} {{ niceDate(reservation.startdate) }} {{ $t("to") }} {{ niceDate(reservation.enddate)}}
              </p>
            </div>
            <div class="row mb-4" v-for="(room, index) in reservation.rooms" :key="'room' + index">
              <div class="col-6 col-md-5">
                <h4>{{ room.title }}</h4>
              </div>
              <div class="col-2 col-md-3">
                <h4>{{ toPrice(room.selectedprice.price) }} </h4>
              </div>
              <div class="col-2">
                <h4>1 </h4>
                <!-- <h4>{{ niceDate(reservation.startdate) }} -  {{ niceDate(reservation.enddate) }}</h4> -->
              </div>
              <div class="col-2 text-right text-end">
                <h4>{{ toPrice(room.selectedprice.price) }}</h4>
              </div>
            </div>
            <div class="row mb-4" v-for="(additional, index) in reservation.additionals" :key="'additional' + index">
              <div class="col-6 col-md-5">
                <h4>{{ additional.title }}</h4>
              </div>
              <div class="col-2 col-md-3">
                <h4>{{ additional.price }} &euro;</h4>
              </div>
              <div class="col-2">
                <h4>{{ additional.amount }}</h4>
              </div>
              <div class="col-2 text-right text-end">
                <h4>{{ toPrice(additional.amount * additional.price) }} </h4>
              </div>
            </div>
            <div class="row service">
              <div class="col-12">
                <hr />
              </div>
              <div class="col-6">
                <p class="mb-0">{{ $t("total") }}:</p>
              </div>
              <div class="col-6 text-right text-end">
                <p class="mb-0">
                  <strong>
                  {{
                      toPrice(reservation.totalAdditionals + reservation.totalRooms)
                  }}
                  </strong>
                </p>
              </div>
            </div>

            <div class="row service">
              <div class="col-12">
                <hr />
              </div>
              <div class="col-6">
                <p class="mb-0">{{ $t("prepayment") }}:</p>
              </div>
              <div class="col-6 text-right text-end">
                <p class="mb-0">
                  <strong>
                  {{
                      toPrice(reservation.total_selected_payment)
                  }}
                  </strong>
                </p>
              </div>
            </div>

          </div>
        </div>
        <div style="margin-top: 50px;">
          <div class="form-row mb-5">
            <div class="row justify-content-between">
              <div class="col-12 col-md-auto mt-2 mb-2">
                <button class="btn btn-primary btn-next" @click="progress.step = 5; initInquiry()">
                  {{ $t("inquiryButton") }}
                </button>
              </div>

              <div class="col-12 col-md-auto mt-2">
                
                <button class="btn btn-primary btn-gradient btn-next" @click="progress.payment.show = true; initSaferpay(); progress.step = 5;">
                  <!-- TODO - please change translation = Commented as the text is too long {{ $t("bookonline") }} --> 
                  {{ $t("bookonline") }}
                </button>
                
              </div>
            </div>
            <div class="row my-5 justify-content-center">
              <div class="col-auto">
                <h1 v-if="error" class="text-danger">{{ error }}</h1>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="row">
              <div class="col-12">
                <p v-if="isBetweenStornoDate(reservation.startdate)" class="text-success mb-2" style="font-size: 17px;">
                  {{ $t("storno1") }}  <stong>{{ isBetweenStornoDate(reservation.startdate) }}</stong> {{ $t("storno2") }} 
                </p>
                <!-- <p>Bitte beachten Sie unsere <a target="_blank" href="https://www.krallerhof.com/de/stornobedingungen">Stornobedingungen.</a> -->
                <p v-html="$t('stornotext')" class="mb-2" style="font-size: 17px;"></p>
                <p class="mb-0" style="font-size: 17px;"> {{ $t("typingerror") }}</p>
            </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="selected" style="margin-top: 50px;">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-md-6">
                  <h1>{{ $t("questions") }}</h1>
                  <p>
                    {{ $t("answer") }}<br />
                    <b>{{ $t("tel2") }}</b>
                  </p>
                </div>
                <div class="col-md-6 d-flex align-items-start">

                  <iframe
                    src="https://api.trustyou.com/hotels/2fb6d7df-c7ce-4bbd-b49f-958fd8d1d83d/trust_score.html?key=b9bf585c-9720-4e58-bfd1-98cabdf65d60&amp;size=l&amp;scale=5"
                    allowtransparency="true" frameborder="0" scrolling="no" height="99px" width="106px"
                    style="display: inline-block;margin-right: 20px;vertical-align: middle;"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </transition>
  <!-- overview end -->
  <!-- payment start -->
  <section class="" v-show="progress.payment.show" :id="progress.payment.name">

    <div>
      <div class="frame frame-default">
        <h4>
          Gesamt: {{ toPrice(reservation.total_selected_payment) }} 
          {{ $t("total") }}:
        </h4>
        <!-- <h4 class="debug">Demo VISA Card number: 9010100052000004</h4> -->
        <div id="payframe-box" class="payframe-box" v-if="paymentLink">
          <div class="payframe-box-inner">
            <iframe id="payframe" v-if="paymentLink" :src="paymentLink" width="100%" height="600"></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- payment end -->
</template>

<script>


export default {
  name: "OrderFormSummary",
  inject: ["reservation", "progress"],

  data() {
    return {
      error: "",
      temp: null,
      paymentLink: "",
    };
  },
  created() {
    window.addEventListener(
      "message",
      function (e) {
        if (document.querySelectorAll("#payframe").length > 0) {
          var frame = document.getElementById("payframe");
          frame.style.height = e.data.height + "px";
        }
      },
      false
    );
    window.document.addEventListener(
      "paymentDone",
      function (e) {
        if (e.detail.success) {
          window.location.replace(e.detail.redirectUrl);
        } else {
          alert("undefined error!!!");
        }
      },
      false
    );
  },
  methods: {

    resetAll() {
      window.location.reload();
    },
    
    initSaferpay() {
     
      this.reservation.total_selected_payment =
        (this.reservation.totalRooms * this.reservation.percent_payment ) / 100;
      this.trackEvent('Booking', 'Buchen in Zusammenfassung', this.reservation.totalRooms );
      this.axios
        .post(this.url + "/rest/v1/payment/init", this.reservation)
        .then((response) => {
          console.log(response.data);
          // PaymentLink update
          window.location.href = response.data.RedirectUrl;
          // this should not be set because of previous redirect line
          this.paymentLink = response.data.RedirectUrl;
        })
        .catch((error) => {

          if (400 == error.response.status) {
            console.log(error.response.status);
            this.error = this.$i18n.t('400');
          }
          if (404 == error.response.status) {
            this.error = error.response.data.errors;
          }
          if (500 == error.response.status) {
            this.error = error.response.data.errors;
          }
          console.log(this.error);
          this.status = error.response.status;
        });
    },
    initInquiry() {
      this.trackEvent('Booking', 'Anfrage in Zusammenfassung', this.reservation.totalRooms );
      this.axios
        .post(this.url + "/rest/v1/order/create", this.reservation)
        .then((response) => {
          var InquiryLink = response.data.RedirectUrl;
          // console.log(InquiryLink)
          // console.log(response)
          window.location.href = InquiryLink;
        })
        .catch((error) => {
          console.log(error.response);
          if (400 == error.response.status) {
            this.error = error.response.data.errors;
          }
          if (404 == error.response.status) {
            this.error = error.response.data.errors;
          }
          if (500 == error.response.status) {
            this.error = error.response.data.errors;
          }
          console.log(this.error);
          this.status = error.response.status;
        });
    },
  },
};
</script>